import { Injectable } from '@angular/core'
import { Column } from '../../models/column.model'
import { TransactionStatus } from '../../models/transactionStatus.model'

// This service is used to store transaction data that is not stored in the db.
// Examples of this data include dropdown options, columns for tables, etc.
// IMPORTANT: Do not add any HTTP requests to this service.
@Injectable({
  providedIn: 'root',
})
export class DataService {
  pendingTransactionColumns: Column[] = [
    {
      field: 'bookm',
      title: '',
      width: 40,
      filterable: false,
      sortable: false,
      hidden: false,
      template: 'bookmark',
    },
    {
      field: 'branchNumber',
      title: 'Branch Number',
      width: 40,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    },
    {
      field: 'blotterId',
      title: 'ID',
      width: 70,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'repName',
      title: 'Rep Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'repName',
    },
    {
      field: 'accountName',
      title: 'Account Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'viewAccount',
    },
    {
      field: 'productTypeDesc',
      title: 'Product',
      width: 120,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'sponsorName',
      title: 'Sponsor',
      width: 100,
      filterable: false,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'productName',
      title: 'Product Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'transactionTypeDesc',
      title: 'Trans Type',
      width: 100,
      filterable: false,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'amount',
      title: 'Amount',
      width: 120,
      filterable: false,
      sortable: true,
      hidden: false,
      template: '',
      format: '{0:c}',
    },
    {
      field: 'dateSubmitted',
      title: 'Date Submitted',
      width: 120,
      filterable: false,
      sortable: true,
      hidden: false,
      template: 'date',
    },
    {
      field: 'statusTypeDesc',
      title: 'Status',
      width: 150,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'statusType',
    },
/*     {
      field: 'reasondescription',
      title: 'Reason',
      width: 50,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    }, */
  ]
  allTransactionColumns: Column[] = [
    {
      field: 'bookm',
      title: '',
      width: 40,
      filterable: false,
      sortable: false,
      hidden: false,
      template: 'bookmark',
    },
    {
      field: 'blotterId',
      title: 'ID',
      width: 70,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'repName',
      title: 'Rep Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'repCode',
      title: 'Rep Code',
      width: 80,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'clientName',
      title: 'Client Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'accountName',
      title: 'Account Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'viewAccount',
    },
    {
      field: 'productTypeDesc',
      title: 'Product',
      width: 120,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'sponsorName',
      title: 'Sponsor',
      width: 80,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'transactionTypeDesc',
      title: 'Trans Type',
      width: 100,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'amount',
      title: 'Amount',
      width: 120,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
      format: '{0:c}',
    },
    {
      field: 'approvedByDate',
      title: 'Date Approved',
      width: 120,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'date',
    },
    {
      field: 'statusTypeDesc',
      title: 'Status',
      width: 150,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'statusType',
    },
    {
      field: 'enteredByRep',
      title: 'Entered By Rep',
      width: 110,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'boolean',
    },
/*     {
      field: 'reasondescription',
      title: 'Reason',
      width: 50,
      filterable: false,
      sortable: false,
      hidden: false,
      template: '',
    }, */
  ]
  clientColumns: Column[] = [
    {
      field: 'clientId',
      title: 'Client ID',
      width: 80,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    },
    {
      field: 'repId',
      title: 'Rep ID',
      width: 80,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    },
    {
      field: 'clientTypeId',
      title: 'Client Type ID',
      width: 80,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    },
    {
      field: 'branchNumber',
      title: 'Branch Number',
      width: 80,
      filterable: false,
      sortable: false,
      hidden: true,
      template: '',
    },
    {
      field: 'repName',
      title: 'Rep Name',
      width: 130,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      // Flexible (no width): shares the leftover horizontal space with the
      // other flexible text columns so the grid fills the page and resizes
      // with the screen, while staying aligned with the header.
      field: 'accountName',
      title: 'Account Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'firstName',
      title: 'First Name',
      filterable: false,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'middleName',
      title: 'Middle Name',
      width: 130,
      filterable: false,
      sortable: true,
      hidden: true,
      template: '',
    },
    {
      field: 'lastName',
      title: 'Last Name',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'city',
      title: 'City',
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'state',
      title: 'State',
      width: 80,
      filterable: true,
      sortable: true,
      hidden: false,
      template: '',
    },
    {
      field: 'dateEntered',
      title: 'Date Entered',
      width: 150,
      filterable: true,
      sortable: true,
      hidden: true,
      template: 'date',
      filter: 'date',
    },
    {
      field: 'modifiedDate',
      title: 'Modified Date',
      width: 150,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'date',
      filter: 'date',
    },
    {
      field: 'accountOpen',
      title: 'Active',
      width: 70,
      filterable: true,
      sortable: true,
      hidden: false,
      template: 'checkbox',
      filter: 'boolean',
    },
/*     {
      field: 'reasondescription',
      title: 'Reason',
      width: 50,
      filterable: false,
      sortable: false,
      hidden: false,
      template: '',
    }, */
  ]
  transactionLinkStatusOptions: TransactionStatus[] = [
    {
      id: -2,
      name: 'Rep Processing Paperwork',
    },
    {
      id: -1,
      name: 'Branch Manager Review',
    },
    {
      id: 0,
      name: 'Processing Paperwork',
    },
    {
      id: 1,
      name: 'Submitted for Review',
    },
    {
      id: 5,
      name: 'Pending - preliminary review complete',
    },
    {
      id: 11,
      name: 'Approved',
    },
  ]
}
